import { NodeViewWrapper } from '@tiptap/react';
import { useTranslation } from 'react-i18next';

import { renderMathFormula } from './math-formula-extension';

import type { MathFormulaOptions } from './math-formula-extension';
import type { NodeViewProps } from '@tiptap/core';

export function MathFormulaView({ node, extension, updateAttributes }: NodeViewProps) {
  const { t } = useTranslation();
  const { onEditRequest } = (extension as unknown as { options: MathFormulaOptions }).options;
  const { html, error } = renderMathFormula(String(node.attrs.latex));

  function handleEdit() {
    onEditRequest(String(node.attrs.latex), (newLatex) => updateAttributes({ latex: newLatex }));
  }

  return (
    <NodeViewWrapper
      as='span'
      className='math-formula cursor-pointer'
      style={{ whiteSpace: 'nowrap' }}
      onDragStart={(e: React.DragEvent) => e.preventDefault()}
      onClick={handleEdit}
      tabIndex={0}
      // The formula ITSELF, not just "Math formula". A generic label tells a screen-reader user
      // that maths is present and nothing about what it says, while the rendered glyphs underneath
      // read as character soup. Matches what reaction-formula-view already does.
      aria-label={`${String(node.attrs.latex ?? '')} — ${t('blocks.toolbar.mathFormulaLabel')}`}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleEdit(); }
      }}
    >
      <span style={{ display: 'block', overflowX: 'auto', overflowY: 'hidden', whiteSpace: 'nowrap', paddingRight: '0.5em' }}>
        {html ? (
          <span dangerouslySetInnerHTML={{ __html: html }} />
        ) : (
          <span className='text-xs' style={{ color: 'var(--color-ws-error-fg)' }}>
            {error ?? String(node.attrs.latex)}
          </span>
        )}
      </span>
    </NodeViewWrapper>
  );
}
